import { useCallback, useState } from "react";

import type {
  BenefitPlan,
  BenefitPlanGroup as ProposalBenefitPlanGroup,
} from "@platform/btx-rates";

// ---------------------------------------------------------------------------
// Rates drawer state — extracted to keep Quotes below the complexity limit
// ---------------------------------------------------------------------------

export const useRatesDrawerState = (): {
  isOpen: boolean;
  benefitPlanGroup: ProposalBenefitPlanGroup | undefined;
  benefitPlanId: string | undefined;
  enableRateSets: boolean;
  open: (
    group: ProposalBenefitPlanGroup,
    plan: BenefitPlan,
    enableRateSets: boolean,
  ) => void;
  close: () => void;
} => {
  const [isOpen, setIsOpen] = useState(false);
  const [selection, setSelection] = useState<{
    benefitPlanGroup: ProposalBenefitPlanGroup;
    benefitPlan: BenefitPlan;
    enableRateSets: boolean;
  }>();

  const open = useCallback(
    (
      group: ProposalBenefitPlanGroup,
      plan: BenefitPlan,
      enableRateSets: boolean,
    ): void => {
      setSelection({
        benefitPlanGroup: group,
        benefitPlan: plan,
        enableRateSets,
      });
      setIsOpen(true);
    },
    [],
  );

  const close = useCallback((): void => {
    setIsOpen(false);
    setSelection(undefined);
  }, []);

  return {
    isOpen,
    benefitPlanGroup: selection?.benefitPlanGroup,
    benefitPlanId: selection?.benefitPlan.id,
    enableRateSets: selection?.enableRateSets ?? false,
    open,
    close,
  };
};
